import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { ChallengeComponent } from './challenge/challenge.component';
import { ErrorFourZeroFourComponent } from './components/error-four-zero-four/error-four-zero-four.component';
import { IndexComponent } from './index/index.component';
import { SharedTopnavComponent } from './shared-topnav/shared-topnav.component';
import { SubindexComponent } from './subindex/subindex.component';
// import { SubindexComponent } from './subindex/subindex.component';
import { AuthGuard } from './_guards/auth.guard';
import { TestsComponent } from './tests/tests.component';

export function detailAndPlay(url: UrlSegment[]) {
    return url.length >= 1
        && (url[0].path.indexOf('play') > -1
            || url[0].path.indexOf('watch') > -1) ?
        { consumed: [] } : null;
}

export function customIndexPage(url: UrlSegment[]) {
    if (url.length === 1) {
        var consumed = false;
        switch (url[0].path) {
            case "movies":
            case "tv-series":
            case "variety":
            case "anime":
            case "sport":
            case "documentary":
            case "drama":
            case "movie":
                consumed = true;
                ;
        };

        return consumed ? { consumed: [] , posParams:{route:new UrlSegment(url[0].path, {})    } } : null;
    }
    else if(url.length == 0){
        return {consumed:[]};
    }
    else
    {
        return null;
    }
}



export function customSubIndexPage(url: UrlSegment[]) {

    if (url.length === 1) {
        var consumed = false;
        switch (url[0].path) {
            case "svideo":
            case "news":
            case "yule":
            case "life":
            case "music":
            case "fashion":
            case "tech":
            case "game":
            case "chinese":
                consumed = true;
                ;
        };

        return consumed ? { consumed: [] } : null;
    }
    else {
        return null;
    }
}


export function searchOrList(url: UrlSegment[]) {
    //console.log(url)
    if (url && url.length >= 1) {
        var consumed = false;
        switch (url[0].path) {
            case "list":
            case "search":
                consumed = true;
                break;
        };
        return consumed ? { consumed: [url[0]] } : null;
    }
    else {
        return null;
    }
}

const routes: Routes = [

    
    {
        matcher:customIndexPage,
        component: SharedTopnavComponent,
        children:[
            {path:"",component:IndexComponent},
            {path:":route",component:SubindexComponent}

        ]
    },
    {
        path: 'challenge', component: ChallengeComponent

    },
    {
        path: 'help',
        loadChildren: () => import("./help-center/help-center.module").then(m => m.HelpCenterModule) //'app/help-center/help-center.module#HelpCenterModule'
    },
    {
        path: 'ad-center',
        loadChildren: () => import("./ad-center/ad-center.module").then(m => m.AdCenterModule) //'app/help-center/help-center.module#HelpCenterModule'
    },

    {
        path: 'rank',
        loadChildren: () => import("./ranking/ranking.module").then(m => m.RankingModule),
        canActivate: []
    },
    {
        path: 'user',
        loadChildren: () => import("./user-center/user-center.module").then(m => m.UserCenterModule),
        canActivate: [AuthGuard]

    },
    {
        path: 'space',
        loadChildren: () => import("./user-space/user-space.module").then(m => m.UserSpaceModule),
    },

    {
        matcher: detailAndPlay,
        loadChildren: () => import("./video/video.module").then(m => m.VideoModule),
        canActivate: [AuthGuard],

    },
    {
        matcher: searchOrList,
        loadChildren: () => import("./search/search.module").then(m => m.SearchModule),
        canActivate: [AuthGuard]

    },
    {
        path: 'vip',
        redirectTo: "vip-center"
    },
    {
        path: 'vip-center',
        loadChildren: () => import("./vip-center/vip-center.module").then(m => m.VipCenterModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'studio',
        loadChildren: () => import("./studio/studio.module").then(m => m.StudioModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'vod',
        loadChildren: () => import("./vod/vod.module").then(m => m.VodModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'notice',
        loadChildren: () => import("./notice/notice.module").then(m => m.NoticeModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'discovery',
        loadChildren: () => import("./discovery/discovery.module").then(m => m.DiscoveryModule),
        // canActivate: [AuthGuard]
    },
    {
        path: 'activity', // 砍价活动
        loadChildren: () => import("./bargain-event/bargain-event.module").then(m => m.BargainEventModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'tvlive', // 电视直播
        loadChildren: () => import("./tv-live/tv-live.module").then(m => m.TvLiveModule),
        canActivate: [AuthGuard]
    },

    {
        path: 'vip-redeem',
        loadChildren: () => import("./vip-redeem/vip-redeem.module").then(m => m.VipRedeemModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'app-download',
        loadChildren: () => import("./app-download/app-download.module").then(m => m.AppDownloadModule),
        canActivate: [AuthGuard]
    },
    {
        path: "404",
        component: ErrorFourZeroFourComponent
    },
    {
        matcher: customIndexPage,
        component: SubindexComponent
    },
    {
        matcher: customSubIndexPage,
        loadChildren: () => import("./short-videos/short-videos.module").then(m => m.ShortVideosModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'invitation',
        redirectTo: "/user/invite"
    },
    // {
    //     path:"test",
    //     component:TestsComponent
    // },
    {
        path: "payment",
        loadChildren: () => import("./payment/payment.module").then(m => m.PaymentModule),

    },
    { path: '**', redirectTo: "404" },
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            // { enableTracing: true }
        )
    ],
    exports: [RouterModule],
    providers: [

    ]
})
export class AppRoutingModule { }
